/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  console.log('onCartUpdate called with:', cart);
  if (cart) {
    Shopify.cartUpdateInfo(cart, '.cart_list');
  } else {
    console.error('Cart is null in onCartUpdate');
  }
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        // Use the existing Shopify.getCart method but show popup after
        if (typeof Shopify.getCart === 'function') {
          // Store the variant_id to use after cart update
          Shopify._pendingPopupVariant = variant_id;
          Shopify.getCart();
        } else {
          // Fallback
          Shopify.cartPopap(variant_id);
          Shopify.onItemAdded(line_item);
        }
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id, callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          // Use the existing Shopify.getCart method but show popup after
          if (typeof Shopify.getCart === 'function') {
            // Store data to use after cart update
            Shopify._pendingPopupVariant = variant_id;
            Shopify._pendingFormId = form_id;
            Shopify.getCart();
          } else {
            // Fallback
            if(form_id != "add-item-qv") {
              Shopify.cartPopapForm(variant_id);
            } else {
              jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
              jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
              setTimeout(function(){
                jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
                jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
              }, 2000);
            }
            Shopify.onItemAdded(line_item);
          }
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var title = jQuery('.'+variant_id+':first .product_title').text();
  	jQuery('.productmsg').text('');
  	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartPopapForm = function(variant_id) {
  	var title = jQuery('.product-info__title:first h2').text();
	jQuery('.productmsg').text('');
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  // Check if cart is valid
  if (!cart) {
    console.error('Cart is null or undefined');
    return;
  }
  
  console.log('Cart data:', cart);
  
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
			
          if (value.length) {
            jQuery(".cart_box.dropdown-menu").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              // Format price safely
              var itemPrice = '';
              try {
                if (item.price && typeof Shopify.formatMoney === 'function') {
                  itemPrice = Shopify.formatMoney(item.price, window.shop_money_format || "{{amount}}");
                } else {
                  itemPrice = (item.price / 100).toFixed(2);
                }
              } catch(e) {
                console.error('Error formatting price:', e);
                itemPrice = (item.price / 100).toFixed(2);
              }
              
              jQuery('<li><a href="javascript:void(0);" class="item_remove" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="ion-close"></i></a><a href="' + item.url + '"><img src="' + item.image + '" alt="cart_thumb1">' + item.title + '</a><span class="cart_quantity">' + item.quantity + ' x <span class="cart_amount"> <span class="price_symbole">' + itemPrice + '</span></span></span></li>').appendTo(table);
            });
          }
          else {
            jQuery(".cart_box.dropdown-menu").css({"display": "none"});
			jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });
    }
  }

  // Format totals safely
  var totalPrice = '';
  try {
    if (cart.total_price && typeof Shopify.formatMoney === 'function') {
      totalPrice = Shopify.formatMoney(cart.total_price, window.shop_money_format || "{{amount}}");
    } else {
      totalPrice = (cart.total_price / 100).toFixed(2);
    }
  } catch(e) {
    console.error('Error formatting total price:', e);
    totalPrice = cart.total_price ? (cart.total_price / 100).toFixed(2) : '0.00';
  }
  
  var itemCount = cart.item_count || 0;
  
  changeHtmlValue(".shopping-cart__total", totalPrice);
  changeHtmlValue(".bigcounter", itemCount);

  jQuery('.currency .active').trigger('click');
  
  // Show popup after cart is updated if there's a pending popup
  if (Shopify._pendingPopupVariant) {
    var variant_id = Shopify._pendingPopupVariant;
    var form_id = Shopify._pendingFormId;
    
    // Clear pending flags
    Shopify._pendingPopupVariant = null;
    Shopify._pendingFormId = null;
    
    if (form_id && form_id == "add-item-qv") {
      jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
      jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
      setTimeout(function(){
        jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
      }, 2000);
    } else if (form_id) {
      Shopify.cartPopapForm(variant_id);
    } else {
      Shopify.cartPopap(variant_id);
    }
  }
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
}